module.exports = __webpack_public_path__ + "static/media/circlediagram.81a6c2a8.svg";